// extracted by mini-css-extract-plugin
module.exports = {"container":"pieChart_container__2UCBq","overlay":"pieChart_overlay__T5X_g","overlaySubtitle":"pieChart_overlaySubtitle__1B7MX","totalNumber":"pieChart_totalNumber__264QH"};